import { Stack } from 'expo-router';

/**
 * Workouts tab stack: the list (`index`) and the detail flow (`(detail)`
 * group, which carries its own header + full-height chrome). Living inside the
 * `(tabs)` navigator keeps the bottom tab bar visible on the detail screens.
 */
export default function WorkoutsLayout() {
  return (
    <Stack screenOptions={{ headerShown: false }}>
      <Stack.Screen name="index" />
      <Stack.Screen name="(detail)" />
    </Stack>
  );
}
